/* ==========================================================================
   Teeser PDP — tsr-pdp.js
   One file drives: variant picker, gallery, add to cart / buy now,
   sticky bar, free-shipping bar, delivery countdown, shoppable videos.
   ========================================================================== */
(() => {
  if (window.__TSR_PDP__) return;
  window.__TSR_PDP__ = true;

  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));
  const mobile = () => window.matchMedia('(max-width: 989px)').matches;

  /* ---------- Money ---------- */
  let MONEY_FORMAT = '{{amount}}';
  const fmt = (cents) => {
    cents = Number(cents) || 0;
    const f = String(MONEY_FORMAT).replace(/<[^>]*>/g, '');
    const n = (dec, thou = ',', sep = '.') => {
      const [i, fr] = (cents / 100).toFixed(dec).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, thou) + (fr ? sep + fr : '');
    };
    const map = {
      amount: () => n(2),
      amount_no_decimals: () => n(0),
      amount_with_comma_separator: () => n(2, '.', ','),
      amount_no_decimals_with_comma_separator: () => n(0, '.', ','),
      amount_with_apostrophe_separator: () => n(2, "'", '.'),
      amount_with_space_separator: () => n(2, ' ', ','),
    };
    const out = f.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => (map[k] || map.amount)());
    return out.replace(/([.,])00(?=\D*$)/, ''); // match Liquid money_without_trailing_zeros
  };

  /* ---------- Toast ---------- */
  let toastEl, toastTimer;
  const toast = (msg, withLinks = true) => {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'tsr tsr-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = `<span></span>${withLinks ? `<span class="tsr-toast__links"><a href="${ROOT}cart">View cart</a><a href="${ROOT}checkout">Checkout</a></span>` : ''}`;
    toastEl.firstChild.textContent = msg;
    requestAnimationFrame(() => toastEl.classList.add('is-visible'));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove('is-visible'), 4500);
  };

  /* ---------- Cart ---------- */
  const getCart = () => fetch(`${ROOT}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());

  const addToCart = async (variantId, qty = 1, sourceId = 'tsr') => {
    const res = await fetch(`${ROOT}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'This item could not be added. Try another size.');
    const cart = await getCart();
    // Horizon + most OS 2.0 themes listen for "cart:update" to refresh the cart count / drawer
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: { resource: cart, sourceId, data: { source: 'tsr-pdp', itemCount: cart.item_count, productId: data.items && data.items[0] && data.items[0].product_id } },
    }));
    document.dispatchEvent(new CustomEvent('tsr:cart', { detail: { cart } }));
    return cart;
  };

  /* ---------- Free-shipping bars ---------- */
  const updateShip = (total) => {
    $$('[data-tsr-ship]').forEach((el) => {
      const threshold = Number(el.dataset.threshold) || 0;
      if (!threshold) return;
      const left = Math.max(threshold - total, 0);
      const pct = Math.min((total / threshold) * 100, 100);
      const msg = left > 0 ? el.dataset.msgProgress.replace('[amount]', fmt(left)) : el.dataset.msgDone;
      const text = $('[data-tsr-ship-text]', el);
      const fill = $('[data-tsr-ship-fill]', el);
      if (text) text.textContent = msg;
      if (fill) fill.style.width = pct + '%';
    });
  };
  document.addEventListener('tsr:cart', (e) => updateShip(e.detail.cart.total_price));

  // Keep the bar in sync with ANY cart change (theme drawer, cart page, apps, qty +/-, remove)
  let shipTimer;
  const refreshShip = () => {
    if (!document.querySelector('[data-tsr-ship]')) return;
    clearTimeout(shipTimer);
    shipTimer = setTimeout(() => { getCart().then((c) => updateShip(c.total_price)).catch(() => {}); }, 300);
  };
  const CART_RE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  const urlOf = (x) => (typeof x === 'string' ? x : (x && (x.url || x.href)) || '');
  if (window.fetch && !window.fetch.__tsr) {
    const _fetch = window.fetch;
    const wrapped = function (...args) {
      const p = _fetch.apply(this, args);
      try {
        if (CART_RE.test(urlOf(args[0]))) p.then((r) => { if (r && r.ok) refreshShip(); }).catch(() => {});
      } catch (_) {}
      return p;
    };
    wrapped.__tsr = true;
    window.fetch = wrapped;
  }
  if (window.XMLHttpRequest) {
    const XO = XMLHttpRequest.prototype.open;
    const XS = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u, ...rest) { this.__tsrUrl = u; return XO.call(this, m, u, ...rest); };
    XMLHttpRequest.prototype.send = function (...a) {
      if (CART_RE.test(String(this.__tsrUrl || ''))) this.addEventListener('load', () => { if (this.status < 400) refreshShip(); });
      return XS.apply(this, a);
    };
  }
  ['cart:update', 'cart:updated', 'cart:refresh', 'cart:change', 'cart:build', 'cart-drawer:refresh', 'ajaxProduct:added', 'theme:cart:change', 'on:cart:add']
    .forEach((ev) => document.addEventListener(ev, (e) => { if (!(e.detail && e.detail.data && e.detail.data.source === 'tsr-pdp')) refreshShip(); }));
  window.addEventListener('pageshow', (e) => { if (e.persisted) refreshShip(); });
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') refreshShip(); });

  /* ---------- Delivery countdown ---------- */
  const tzNow = (tz) => {
    try {
      const p = new Intl.DateTimeFormat('en-GB', { timeZone: tz, hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
      const g = (t) => Number((p.find((x) => x.type === t) || {}).value || 0);
      return g('hour') * 3600 + g('minute') * 60 + g('second');
    } catch (_) {
      const d = new Date();
      return d.getHours() * 3600 + d.getMinutes() * 60 + d.getSeconds();
    }
  };
  const runEta = () => {
    $$('[data-tsr-eta]').forEach((el) => {
      const cutoff = Number(el.dataset.cutoff) * 3600;
      const now = tzNow(el.dataset.tz || 'Asia/Dubai');
      let left = cutoff - now;
      const before = left > 0;
      if (!before) left += 86400;
      const h = Math.floor(left / 3600);
      const m = Math.floor((left % 3600) / 60);
      const t = $('[data-tsr-eta-time]', el);
      const d = $('[data-tsr-eta-day]', el);
      if (t) t.textContent = `${h}h ${m}m`;
      if (d) d.textContent = before ? el.dataset.before : el.dataset.after;
      el.hidden = false;
    });
  };
  setInterval(runEta, 30000);

  /* ======================================================================
     Product controller
     ====================================================================== */
  class TsrProduct {
    constructor(root) {
      this.root = root;
      const json = $('[data-tsr-json]', root);
      if (!json) return;
      this.data = JSON.parse(json.textContent);
      MONEY_FORMAT = this.data.moneyFormat || MONEY_FORMAT;
      this.variants = this.data.variants;
      this.picker = $('[data-tsr-picker]', root);
      this.colourIndex = -1;
      const cg = this.picker && $('[data-tsr-group][data-colour]', this.picker);
      if (cg) this.colourIndex = Number(cg.dataset.index);
      const start = this.variants.find((v) => v.id === this.data.selectedId) || this.variants[0];
      this.selected = start.options.slice();
      this.initGallery();
      this.bind();
      this.update(start, false);
      this.initSticky();
    }

    /* ----- events ----- */
    bind() {
      this.initReviewsPopup();
      this.root.addEventListener('click', (e) => {
        const rev = e.target.closest('[data-tsr-reviews-open]');
        if (rev) { if (this.openReviews()) e.preventDefault(); return; }
        const opt = e.target.closest('[data-tsr-opt]');
        if (opt) return this.onOption(opt);
        const atc = e.target.closest('[data-tsr-atc]');
        if (atc) { e.preventDefault(); return this.onAdd(atc, false); }
        const now = e.target.closest('[data-tsr-buynow]');
        if (now) { e.preventDefault(); return this.onAdd(now, true); }
      });
      const form = $('form[data-tsr-form]', this.root);
      if (form) form.addEventListener('submit', (e) => { e.preventDefault(); const b = $('[data-tsr-atc]', this.root); if (b) this.onAdd(b, false); });
    }

    onOption(btn) {
      const i = Number(btn.dataset.index);
      this.selected[i] = btn.dataset.value;
      let v = this.find(this.selected);
      if (!v) {
        const same = this.variants.filter((x) => x.options[i] === btn.dataset.value);
        v = same.find((x) => x.available) || same[0];
        if (v) this.selected = v.options.slice();
      }
      if (v) this.update(v, true, i === this.colourIndex);
    }

    find(opts) { return this.variants.find((v) => v.options.every((o, i) => o === opts[i])); }

    /* ----- availability per option value (relative to options before it) ----- */
    valueAvailable(index, value) {
      return this.variants.some((v) => v.available && v.options[index] === value && v.options.slice(0, index).every((o, k) => o === this.selected[k]));
    }

    update(v, user, colourChanged = true) {
      this.variant = v;
      const r = this.root;

      // hidden input
      $$('[data-tsr-id]', r).forEach((el) => (el.value = v.id));

      // prices
      $$('[data-tsr-price]', r).forEach((el) => (el.textContent = fmt(v.price)));
      const onSale = v.compare > v.price;
      $$('[data-tsr-compare]', r).forEach((el) => { el.hidden = !onSale; el.textContent = onSale ? fmt(v.compare) : ''; });
      $$('[data-tsr-pct]', r).forEach((el) => { el.hidden = !onSale; if (onSale) el.textContent = `\u2212${Math.round(((v.compare - v.price) / v.compare) * 100)}%`; });
      $$('[data-tsr-split]', r).forEach((el) => (el.textContent = fmt(Math.floor(v.price / 4))));
      $$('[data-tsr-bundle-total]', r).forEach((el) => (el.textContent = fmt(v.price * (Number(el.dataset.pay) || 2))));
      $$('[data-tsr-bundle-each]', r).forEach((el) => (el.textContent = fmt(Math.floor((v.price * (Number(el.dataset.pay) || 2)) / (Number(el.dataset.qty) || 3)))));
      $$('[data-tsr-variant-title]', r).forEach((el) => (el.textContent = this.data.single ? '' : v.title));

      // option buttons
      $$('[data-tsr-opt-label]', r).forEach((el) => (el.textContent = this.selected[Number(el.dataset.tsrOptLabel)] || ''));
      $$('[data-tsr-opt]', r).forEach((b) => {
        const i = Number(b.dataset.index);
        const on = this.selected[i] === b.dataset.value;
        const ok = this.valueAvailable(i, b.dataset.value);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.classList.toggle('is-unavailable', !ok);
        const lab = $('[data-tsr-swatch-label]', b);
        if (lab) lab.textContent = ok ? lab.dataset.label : (lab.dataset.soldout || lab.dataset.label);
      });

      // availability → buttons
      const avail = v.available;
      $$('[data-tsr-atc],[data-tsr-buynow]', r).forEach((el) => (el.hidden = !avail));
      $$('[data-tsr-notify]', r).forEach((el) => {
        el.hidden = avail;
        if (avail) return;
        const size = v.options[v.options.length - 1] || '';
        const t = $('[data-tsr-notify-text]', el);
        if (t && t.dataset.tpl) t.textContent = t.dataset.tpl.replace('[size]', size).replace('[variant]', v.title);
        const wa = el.dataset.wa;
        if (wa) {
          const msg = (el.dataset.msg || '').replace('[product]', this.data.title).replace('[variant]', v.title);
          el.href = `https://wa.me/${wa}?text=${encodeURIComponent(msg)}`;
        }
      });

      // low stock
      const low = this.picker ? Number(this.picker.dataset.low) || 0 : 0;
      $$('[data-tsr-low]', r).forEach((el) => {
        const show = avail && low > 0 && v.managed === 'shopify' && v.policy === 'deny' && v.inv > 0 && v.inv <= low;
        el.hidden = !show;
        if (show) {
          const tpl = el.dataset.tpl || 'Low stock in [size] — order soon';
          $('[data-tsr-low-text]', el).textContent = tpl.replace('[size]', v.options[v.options.length - 1]).replace('[count]', v.inv);
        }
      });

      // sticky image
      $$('[data-tsr-sticky-img]', r).forEach((img) => { if (v.image) img.src = v.image; });

      // gallery
      if (colourChanged) this.filterGallery();
      if (user && v.media) this.goToMedia(v.media);

      // URL
      if (user && this.data.updateUrl) {
        const u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      }
      $$('[data-tsr-error]', r).forEach((el) => (el.hidden = true));
    }

    /* ----- reviews popup ----- */
    initReviewsPopup() {
      const dlg = $('[data-tsr-reviews-dialog]', this.root);
      if (!dlg) return;
      this.dlg = dlg;
      $('[data-tsr-dialog-close]', dlg).addEventListener('click', () => dlg.close());
      dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
      dlg.addEventListener('close', () => this.restoreReviews());
    }

    openReviews() {
      const dlg = this.dlg;
      if (!dlg || typeof dlg.showModal !== 'function') return false;
      if (dlg.open) return true;
      const sels = (dlg.dataset.source || '').split(',').map((x) => x.trim()).filter(Boolean);
      let src = null;
      for (const sel of sels) {
        let el = null;
        try { el = document.querySelector(sel); } catch (_) { el = null; }
        if (el && !dlg.contains(el) && !el.contains(dlg)) { src = el; break; }
      }
      if (!src) return false;
      const body = $('[data-tsr-dialog-body]', dlg);
      // Teeser Reviews section → rebuild as clean light cards (no dark block inside the popup)
      if (src.id === 'tsr-reviews' || src.classList.contains('tsr-rev')) {
        const cards = $$('.tsr-rev__card', src);
        if (!cards.length) return false;
        body.innerHTML = '';
        const grid = document.createElement('div');
        grid.className = 'tsr-dlg-grid';
        cards.forEach((c) => {
          const clone = c.cloneNode(true);
          clone.removeAttribute('data-shopify-editor-block');
          grid.appendChild(clone);
        });
        body.appendChild(grid);
        const cta = $('.tsr-rev__cta--d', src);
        const href = cta && cta.getAttribute('href');
        if (href && href.charAt(0) !== '#') {
          const a = cta.cloneNode(true);
          a.removeAttribute('data-tsr-reviews-open');
          a.className = 'tsr-btn tsr-dlg-cta';
          body.appendChild(a);
        }
        dlg.showModal();
        document.documentElement.style.overflow = 'hidden';
        body.scrollTop = 0;
        return true;
      }
      this.placeholder = document.createComment('tsr-reviews-home');
      src.parentNode.insertBefore(this.placeholder, src);
      body.innerHTML = '';
      body.appendChild(src);
      this.moved = src;
      dlg.showModal();
      document.documentElement.style.overflow = 'hidden';
      body.scrollTop = 0;
      return true;
    }

    restoreReviews() {
      document.documentElement.style.overflow = '';
      if (this.moved && this.placeholder && this.placeholder.parentNode) {
        this.placeholder.parentNode.insertBefore(this.moved, this.placeholder);
        this.placeholder.remove();
      }
      this.moved = null;
      this.placeholder = null;
    }

    /* ----- add to cart / buy now ----- */
    async onAdd(btn, buyNow) {
      if (!this.variant || !this.variant.available) return;
      btn.setAttribute('aria-busy', 'true');
      try {
        await addToCart(this.variant.id, 1, this.root.id);
        if (buyNow) { window.location.href = `${ROOT}checkout`; return; }
        if (this.root.dataset.afterAdd === 'cart') { window.location.href = `${ROOT}cart`; return; }
        toast(`${this.data.title}${this.data.single ? '' : ' (' + this.variant.title + ')'} added to cart`);
      } catch (err) {
        $$('[data-tsr-error]', this.root).forEach((el) => { el.textContent = err.message; el.hidden = false; });
        if (btn.closest('[data-tsr-sticky]')) toast(err.message, false);
      } finally {
        btn.removeAttribute('aria-busy');
      }
    }

    /* ----- gallery ----- */
    initGallery() {
      this.track = $('[data-tsr-track]', this.root);
      if (!this.track) return;
      this.slides = $$('[data-tsr-slide]', this.track);
      this.thumbs = $$('[data-tsr-thumb]', this.root);
      this.countEl = $('[data-tsr-count]', this.root);
      this.totalEl = $('[data-tsr-total]', this.root);
      this.thumbs.forEach((t) => t.addEventListener('click', () => this.goToMedia(Number(t.dataset.mediaId), true)));
      // Mobile dots (built from slides; rebuilt when the colour filter changes)
      this.dotsEl = document.createElement('div');
      this.dotsEl.className = 'tsr-dots';
      this.dotsEl.setAttribute('role', 'tablist');
      this.track.parentNode.appendChild(this.dotsEl);
      this.dotsEl.addEventListener('click', (e) => {
        const d = e.target.closest('[data-media-id]');
        if (d) this.goToMedia(Number(d.dataset.mediaId), true);
      });
      this.buildDots();
      const step = (d) => {
        const vis = this.visibleSlides();
        if (vis.length < 2) return;
        const w = this.track.clientWidth || 1;
        const i = (Math.round(this.track.scrollLeft / w) + d + vis.length) % vis.length;
        this.track.scrollTo({ left: vis[i].offsetLeft, behavior: 'smooth' });
      };
      const prev = $('[data-tsr-gprev]', this.root);
      const next = $('[data-tsr-gnext]', this.root);
      if (prev) prev.addEventListener('click', () => step(-1));
      if (next) next.addEventListener('click', () => step(1));
      let raf;
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => this.syncIndex());
      }, { passive: true });
    }

    visibleSlides() { return (this.slides || []).filter((s) => !s.hidden); }

    buildDots() {
      if (!this.dotsEl) return;
      const vis = this.visibleSlides();
      this.dotsEl.hidden = vis.length < 2;
      this.dotsEl.innerHTML = vis.map((s, i) => `<button type="button" class="tsr-dot" data-media-id="${s.dataset.mediaId}" aria-label="Image ${i + 1}"></button>`).join('');
    }

    syncIndex() {
      const vis = this.visibleSlides();
      if (!vis.length) return;
      const w = this.track.clientWidth || 1;
      const idx = Math.min(Math.round(this.track.scrollLeft / w), vis.length - 1);
      if (this.countEl) this.countEl.textContent = idx + 1;
      if (this.totalEl) this.totalEl.textContent = vis.length;
      const id = vis[idx].dataset.mediaId;
      this.thumbs.forEach((t) => t.setAttribute('aria-current', t.dataset.mediaId === id ? 'true' : 'false'));
      if (this.dotsEl) $$('.tsr-dot', this.dotsEl).forEach((d) => d.setAttribute('aria-current', d.dataset.mediaId === id ? 'true' : 'false'));
    }

    filterGallery() {
      if (!this.slides || this.root.dataset.colourFilter !== 'true' || this.colourIndex < 0) return this.syncIndex();
      const colour = (this.selected[this.colourIndex] || '').toLowerCase().trim();
      const match = (s) => (s.dataset.alt || '').split('|').map((x) => x.trim()).includes(colour) || (s.dataset.alt || '').trim() === colour;
      const any = this.slides.some(match);
      this.slides.forEach((s) => (s.hidden = any ? !match(s) : false));
      this.thumbs.forEach((t) => {
        const s = this.slides.find((x) => x.dataset.mediaId === t.dataset.mediaId);
        t.hidden = s ? s.hidden : false;
      });
      this.track.scrollTo({ left: 0 });
      this.buildDots();
      this.syncIndex();
    }

    goToMedia(id, fromThumb = false) {
      if (!this.slides) return;
      const slide = this.slides.find((s) => Number(s.dataset.mediaId) === Number(id));
      if (!slide || slide.hidden) return;
      this.track.scrollTo({ left: slide.offsetLeft, behavior: fromThumb ? 'smooth' : 'auto' });
      setTimeout(() => this.syncIndex(), 350);
    }

    /* ----- sticky bar ----- */
    initSticky() {
      const bar = $('[data-tsr-sticky]', this.root);
      const target = $('[data-tsr-buy]', this.root);
      if (!bar || !target || !('IntersectionObserver' in window)) return;
      const set = (show) => {
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (show) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
      };
      set(false);
      new IntersectionObserver(([e]) => set(!e.isIntersecting && e.boundingClientRect.top < 0), { threshold: 0 }).observe(target);
    }
  }

  /* ======================================================================
     Shoppable videos
     ====================================================================== */
  class TsrVideos {
    constructor(root) {
      this.root = root;
      const track = $('[data-tsr-vtrack]', root);
      const step = () => { const c = track && track.firstElementChild; return c ? c.getBoundingClientRect().width + 12 : 300; };
      const prev = $('[data-tsr-prev]', root);
      const next = $('[data-tsr-next]', root);
      if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step() }));
      if (next) next.addEventListener('click', () => track.scrollBy({ left: step() }));

      root.addEventListener('click', async (e) => {
        const play = e.target.closest('[data-tsr-play]');
        const media = e.target.closest('.tsr-vid__media');
        if (play || (media && $('video', media))) {
          const card = e.target.closest('.tsr-vid');
          const vid = $('video', card);
          if (!vid) return;
          if (vid.paused) {
            $$('video', root).forEach((o) => { if (o !== vid && !o.autoplay) { o.pause(); o.closest('.tsr-vid').classList.remove('is-playing'); } });
            vid.muted = false; vid.play(); card.classList.add('is-playing');
          } else { vid.pause(); card.classList.remove('is-playing'); }
          return;
        }
        const toggle = e.target.closest('[data-tsr-quick-toggle]');
        if (toggle) {
          const panel = $('[data-tsr-quick-panel]', toggle.closest('.tsr-vid'));
          const open = panel.hidden;
          $$('[data-tsr-quick-panel]', root).forEach((p) => (p.hidden = true));
          $$('[data-tsr-quick-toggle]', root).forEach((t) => t.setAttribute('aria-expanded', 'false'));
          panel.hidden = !open;
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          return;
        }
        const add = e.target.closest('[data-tsr-quick-add]');
        if (add) {
          add.setAttribute('aria-busy', 'true');
          try {
            await addToCart(add.dataset.tsrQuickAdd, 1, root.id);
            const panel = add.closest('[data-tsr-quick-panel]');
            if (panel) panel.hidden = true;
            toast(`${add.dataset.title || 'Item'} added to cart`);
          } catch (err) { toast(err.message, false); }
          add.removeAttribute('aria-busy');
        }
      });
    }
  }

  /* ---------- Reviews mix: different order per product (or per visit) ---------- */
  const mixReviews = (root) => {
    if (!root || root.__tsrMixed) return;
    root.__tsrMixed = true;
    const mode = root.dataset.mix || 'product';
    const track = $('[data-tsr-vtrack]', root);
    if (!track || mode === 'fixed') return;
    let seed = mode === 'visit' ? Math.floor(Math.random() * 2147483647) : (Number(String(root.dataset.seed).slice(-9)) || 1);
    const rand = () => { seed |= 0; seed = (seed + 0x6D2B79F5) | 0; let t = Math.imul(seed ^ (seed >>> 15), 1 | seed); t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t; return ((t ^ (t >>> 14)) >>> 0) / 4294967296; };
    const shuffle = (a) => { for (let i = a.length - 1; i > 0; i--) { const k = Math.floor(rand() * (i + 1)); [a[i], a[k]] = [a[k], a[i]]; } return a; };
    const cards = Array.from(track.children).filter((c) => c.classList.contains('tsr-rev__card'));
    const groups = { 1: [], 2: [], 3: [], 4: [] };
    cards.forEach((c) => (groups[c.dataset.group] || groups[4]).push(c));
    const ordered = [].concat(shuffle(groups[1]), shuffle(groups[2]), shuffle(groups[3]), shuffle(groups[4]));
    const max = Number(root.dataset.max) || 8;
    ordered.forEach((c, i) => { c.classList.toggle('tsr-rev__card--more', i >= max); track.appendChild(c); });
  };

  /* ---------- Trustoo: hide its review list, reuse its "Write a review" form ---------- */
  const TRUSTOO_RE = /vstar|trustoo/i;
  const inTrustoo = (el) => { for (let n = el; n && n !== document.body; n = n.parentElement) { if (TRUSTOO_RE.test((n.id || '') + ' ' + (typeof n.className === 'string' ? n.className : ''))) return true; } return false; };
  const findTrustooWriteBtn = (label) => {
    const want = String(label || 'Write a review').trim().toLowerCase();
    const els = $$('button, a, [role="button"], div, span').filter((el) => {
      if (el.closest('.tsr')) return false;
      if (el.children.length > 2) return false;
      return (el.textContent || '').trim().toLowerCase() === want && inTrustoo(el);
    });
    // pick the innermost match (the real button), not a wrapper with the same text
    return els.find((c) => !els.some((o) => o !== c && c.contains(o))) || null;
  };
  const trustooRoot = (el) => {
    const block = el.closest('.shopify-app-block, [id^="shopify-block-"]');
    if (block) return block;
    let root = el, n = el;
    while (n && n !== document.body) { if (TRUSTOO_RE.test((n.id || '') + ' ' + (typeof n.className === 'string' ? n.className : ''))) root = n; n = n.parentElement; if (n && n.matches && n.matches('.shopify-section, main, body')) break; }
    return root;
  };
  const hideTrustoo = (label) => {
    const btn = findTrustooWriteBtn(label);
    if (!btn) return false;
    const root = trustooRoot(btn);
    if (root && !root.closest('[data-tsr-product]') && !root.classList.contains('tsr')) root.classList.add('tsr-trustoo-hidden');
    return true;
  };
  const initTrustoo = (rev) => {
    const writeBtn = $('[data-tsr-write-review]', rev);
    const label = writeBtn ? writeBtn.dataset.label : 'Write a review';
    if (rev.dataset.hideTrustoo === 'true') {
      if (!hideTrustoo(label)) {
        const mo = new MutationObserver(() => { if (hideTrustoo(label)) mo.disconnect(); });
        mo.observe(document.body, { childList: true, subtree: true });
        setTimeout(() => mo.disconnect(), 20000);
      }
    }
    if (writeBtn) writeBtn.addEventListener('click', () => {
      const btn = findTrustooWriteBtn(label);
      if (!btn) {
        if (writeBtn.dataset.fallback) window.location.href = writeBtn.dataset.fallback;
        else toast('Review form is still loading — please try again in a moment.', false);
        return;
      }
      btn.click();
      // If Trustoo opened its form inside the hidden widget, reveal the widget so the form is visible
      setTimeout(() => {
        const root = trustooRoot(btn);
        const visibleModal = $$('body *').some((el) => inTrustoo(el) && !el.closest('.tsr-trustoo-hidden') && getComputedStyle(el).position === 'fixed' && el.offsetWidth > 0 && el.offsetHeight > 0);
        if (!visibleModal && root && root.classList.contains('tsr-trustoo-hidden')) {
          root.classList.remove('tsr-trustoo-hidden');
          if (root.scrollIntoView) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
          btn.click();
        }
      }, 500);
    });
  };

  /* ---------- Boot ---------- */
  const boot = (scope = document) => {
    $$('[data-tsr-product]', scope).forEach((el) => { if (!el.__tsr) el.__tsr = new TsrProduct(el); });
    $$('[data-tsr-vids]', scope).forEach((el) => { if (!el.__tsr) el.__tsr = new TsrVideos(el); });
    $$('#tsr-reviews[data-mix]', scope).forEach(mixReviews);
    $$('#tsr-reviews', scope).forEach((el) => { if (!el.__tsrTrustoo) { el.__tsrTrustoo = true; initTrustoo(el); } });
    runEta();
    refreshShip();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
  // "Read all reviews" (outside the product section) → reuse the product's reviews popup
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-tsr-reviews-open]');
    if (!btn || btn.closest('[data-tsr-product]')) return;
    const prod = document.querySelector('[data-tsr-product]');
    if (prod && prod.__tsr && prod.__tsr.openReviews && prod.__tsr.openReviews()) e.preventDefault();
  });
  document.addEventListener('shopify:block:select', () => runEta());
})();